export default __webpack_public_path__ + "img/dropdown.6e432424.svg";